'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');
var processInclude = require('base/util');
const { CLASSES } = require('./utils/globals');

const SELECTORS = {
    stickyHeader: '.header-container',
}

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('eminence/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('eminence/components/miniCart'));
    processInclude(require('eminence/login'));
    processInclude(require('eminence/components/collapsibleItem'));
    processInclude(require('eminence/components/search'));
    processInclude(require('eminence/components/clientSideValidation'));
    processInclude(require('eminence/components/fieldPhoneNumberFormat'));
    processInclude(require('eminence/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('eminence/components/select2'));
    processInclude(require('eminence/components/slickSlider'));
    processInclude(require('eminence/components/newsletter'));
    processInclude(require('eminence/components/globalNotifications'));

    processInclude(require('eminence/debug')); // remove later
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');


/**
* Handles the sticky header and search column layout on scroll, resize, and load events.
*
* Adds or removes the sticky class to the header based on scroll position, and adjusts the search column's
* layout class depending on whether the view is desktop-sized and the header is sticky.
*
* @event window#scroll
* @event window#resize
* @event window#load
* @listens window#scroll
* @listens window#resize
* @listens window#load
*
* @global
*/
$(window).on('scroll resize load', function () {
    const $header = $(SELECTORS.stickyHeader);
    const $searchCol = $('.js-header-search');
    const isSticky = $(window).scrollTop() >= 80;
    const isDesktop = window.innerWidth >= 900;

    $header.toggleClass(CLASSES.sticky, isSticky);

    const isWideLayout = isDesktop && !isSticky;

    $searchCol.toggleClass('l-col-auto', !isWideLayout);
    $searchCol.toggleClass('l-col-4', isWideLayout);
});

$(function(){
    if ($('#country-prompt').length > 0) {
        $('.countryCta').trigger('click');
    }
});
